import { Reducer, createSlice } from "@reduxjs/toolkit";
import localforage from "localforage";

import i18n from "../../i18n-config";
import { RootState } from "../state";


export declare interface UIState {
  snackbarUserUi: {
    visible: boolean;
    message?: string;
    color?: string;
    icon?: "check",
  };
  lang: string;
  sessionExpired: boolean;
}

const initialState: UIState = {
  snackbarUserUi: {
    visible: false,
    message: "",
    color: "",
    icon: "check",
  },
  lang:'',
  sessionExpired: false,
}

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    showSnackbarUserUi: (state: UIState, { payload }) => {
      state.snackbarUserUi = { ...state.snackbarUserUi, ...payload };
    },
    hideSnackbarUserUi: (state: UIState, { payload }) => {
      state.snackbarUserUi.visible = false;
    },
    changeLang: (state: UIState, action) => {
      state.lang = action.payload;
      return state;
    },
    toggleSessionExpired: (state: UIState, action) => {
      state.sessionExpired = action.payload;
      return state;
    },
  },
});

export const {
  showSnackbarUserUi,
  hideSnackbarUserUi,
  changeLang,
  toggleSessionExpired
} = uiSlice.actions;

//async actions
export const snackbarUserUiSelector = (state: RootState) => state.ui.snackbarUserUi;

export default uiSlice.reducer as Reducer<UIState>;

export const changeOrInitAsyncLang =
  ({ lang = "", init = false }) =>
  async (dispatch: any) => {
    try {
      const current_lang = lang;
      if (!init) {
        await localforage.setItem("LANG", lang);
      } else {
        // current_lang =
        //   (await localforage.getItem('LANG')) || locale.slice(0, 2);
        // await localforage.setItem('LANG', current_lang);
      }
      i18n.changeLanguage(current_lang);
      dispatch(changeLang(current_lang));
    } catch (error) {
      console.log("change lang error", error);
    }
  };

// get device location
export const detectCountry = () => async () => {
  try {
    console.log("inside get device location");
    
  } catch (error) {
    console.log("detect country error: " + error);
  }
};
